/* @flow */

export const validation = {
  maxTitleChar: 100,
  maxParagraphChar: 300,
  slides: {
    min: 1,
    max: 20
  }
}